import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { forgottenPassword } from './actions';
import ForgottenPasswordForm from './ForgottenPasswordForm';
import { Grid, Row, Col, Breadcrumb } from 'react-bootstrap';
import LanguageMenu from '../languages/LanguageMenu';
import { withTranslation } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';
import { FORGOTTEN_PASSWORD_REQUEST, FORGOTTEN_PASSWORD_SUCCESS, FORGOTTEN_PASSWORD_FAILURE } from './actions';

class ForgottenPassword extends React.Component {

	constructor(props) {
		super(props);
		this.handleOnSubmit = this.handleOnSubmit.bind(this);
	}

	componentDidMount() {
		document.body.classList.add('login-background');
	}

	componentWillUnmount() {
		document.body.classList.remove('login-background');
	}

	handleOnSubmit(values) {
		const { forgottenPassword, history } = this.props;

		forgottenPassword(values, history);

	}

	render() {

		const { t, email, franchisor, languages } = this.props;
		const logoImg = franchisor && franchisor.logoUrl;

		return (
			<Grid fluid>
				<Row>
					<Col>
						<Breadcrumb className='login-breadcrumb'>
							{languages.length > 1 && <LanguageMenu languages={languages} />}
						</Breadcrumb>
					</Col>
				</Row>
				<Row className='body-simulate'>
					<div className='login example2'>
						<div className='main-login col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3'>							
							{logoImg && <div className='logo'><img src={logoImg} /></div>}
							{!logoImg && <div className='logo'>{t('ForgottenPassword_Title', { systemName: franchisor && franchisor.systemName.toUpperCase() })}</div>}
							<ReduxBlockUi block={FORGOTTEN_PASSWORD_REQUEST} unblock={[FORGOTTEN_PASSWORD_SUCCESS, FORGOTTEN_PASSWORD_FAILURE]}>
								<div className='box-login'>
									<h3>{t('ForgottenPassword_ForgottenPassword')}</h3>
									<p>{t('ForgottenPassword_Text')}</p>
									<ForgottenPasswordForm onSubmit={this.handleOnSubmit} email={email} />
								</div>
							</ReduxBlockUi>
						</div>
					</div>
				</Row>
			</Grid>
		);
	}

}

ForgottenPassword.propTypes = {
	forgottenPassword: PropTypes.func,
	location: PropTypes.object,
	isAuthenticated: PropTypes.bool,
	errors: PropTypes.array
};

const mapStateToProps = (state, ownProps) => {
	const { email } = queryString.parse(ownProps.location.search);
	const { configuration: { franchisor }, lookups: { languages } } = state;
	return {
		email,
		franchisor,
		languages
	};
};

export default connect(mapStateToProps, { forgottenPassword })(withTranslation()(ForgottenPassword));